function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
import regeneratorRuntime from "/vercel/path0/node_modules/next/dist/compiled/regenerator-runtime/runtime.js";
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  width: 100%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  height: ",
        "px;\n  background-color: ",
        ";\n  border-bottom: 1px solid ",
        ";\n  transform: translate3d(0, 0, 0);\n\n  padding-left: 16px;\n  padding-right: 16px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  position: fixed;\n  top: ",
        ";\n  left: 0;\n  transition: top 0.2s;\n  height: ",
        ";\n  width: 100%;\n  z-index: 20;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  height: ",
        ";\n  min-height: ",
        ";\n  max-height: ",
        ";\n  width: 100%;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  flex-grow: 1;\n  transition: margin-top 0.2s, margin-left 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n  transform: translate3d(0, 0, 0);\n  max-width: 100%;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import throttle from "lodash/throttle";
import React, { useEffect, useRef, useState, Fragment } from "react";
import styled from "styled-components";
import { Dialog, Transition, Disclosure } from "@headlessui/react";
import { XMarkIcon, ChevronDownIcon, Bars3Icon } from "@heroicons/react/24/outline";
import toast, { Toaster } from "react-hot-toast";
import clsx from "clsx";
import { Box } from "../../components/Box";
import Footer from "../../components/Footer";
import { useMatchBreakpoints } from "../../hooks";
import { MENU_HEIGHT, TOP_BANNER_HEIGHT, TOP_BANNER_HEIGHT_MOBILE } from "./config";
import { MenuContext } from "./context";
import TokenPrice from "./TokenPrice";
import PriceBNB from "./PriceBNB";
import CarouselBanner from "./Carousel";
import TradeTabs from "./TradeTabs";
import { useCountdown } from "./useCountdown";
import ImgS3, { getS3Url_V3 } from "./ImgS3";
/* @ts-nocheck */ var createMenuItem = function(name, href, src) {
    var options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return _objectSpread({
        name: name,
        href: href,
        src: src,
        current: false,
        target: true
    }, options);
};
var Link = function(param) {
    var children = param.children, href = param.href, _className = param.className, className = _className === void 0 ? "" : _className, _target = param.target, target = _target === void 0 ? "_self" : _target, _isExternal = param.isExternal, isExternal = _isExternal === void 0 ? false : _isExternal, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled, onClick = param.onClick;
    var handleClick = function(e) {
        if (disabled) {
            e.preventDefault();
            return;
        }
        if (onClick) {
            onClick(e);
        }
    };
    var externalProps = isExternal ? {
        target: "_blank",
        rel: "noopener noreferrer"
    } : {};
    return /*#__PURE__*/ _jsxs("a", _objectSpread({
        href: href,
        className: className,
        onClick: handleClick,
        target: target
    }, externalProps, {
        children: [
            children,
            isExternal && /*#__PURE__*/ _jsx("svg", {
                className: "w-4 h-4 ml-1",
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24",
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ _jsx("path", {
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: 2,
                    d: "M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                })
            })
        ]
    }));
};
// Updated navigation with white icons
var navigation = [
    createMenuItem("APK CRP Android", "https://s3.magic-api.xyz/beats-miner-v3/app-analytics-debug.apk", "/icons/apk-crp-white.png"),
    createMenuItem("CoinMarketCap", "https://coinmarketcap.com/currencies/crytopeso/", "/icons/cmc-white.png"),
    createMenuItem("Coingecko", "https://www.coingecko.com/en/coins/cryptopeso", "/icons/cg-white.png"),
    createMenuItem("Poocoin CRP", "https://poocoin.app/tokens/0x86333e34c8804532ae34207c46e741cbc3ff3fe3", "/icons/popcoin-white.png"),
    createMenuItem("Dexcreener CRP", "https://dexscreener.com/bsc/0x8F37DFED89DaCa1ffe6c8D51FCD34da95f9Db2C6", "/icons/dexcreener-white.png"),
    createMenuItem("Dextool CRP", "https://www.dextools.io/app/en/bnb/pair-explorer/0x8f37dfed89daca1ffe6c8d51fcd34da95f9db2c6?t=1717030280040", "/icons/dextools-white.png"),
    createMenuItem("Dexview CRP", "https://www.dexview.com/bsc/0x86333e34c8804532Ae34207c46e741cBc3Ff3FE3", "/icons/dexview-white.png"),
    createMenuItem("Tradingview CRP", "https://es.tradingview.com/symbols/CRPWBNB_8F37DF.USD/?exchange=PANCAKESWAP&utm_source=iosapp&utm_medium=share", "/icons/tradingview-white.png"),
    createMenuItem("Pancakeswap CRP", "https://pancakeswap.finance/swap?outputCurrency=0x86333e34c8804532Ae34207c46e741cBc3Ff3FE3&inputCurrency=BNB", "/icons/pancake-white.png"),
    createMenuItem("CRPswap", "https://crpswap.cryptopeso.co", "/icons/swap-white.png"), 
];
// Updated cryptoPeso with white icons and new items
var cryptoPeso = [
    createMenuItem("CRPminer", "https://miner.cryptopeso.co", "/icons/v5-white.png"),
    createMenuItem("CRPstaking", "https://staking.cryptopeso.co/", "/icons/staking-white.png"),
    createMenuItem("CRPairdrop", "https://airdrop.cryptopeso.co/", "/icons/airdrop-white.png"),
    createMenuItem("Cryptominers NFT", "https://nft.cryptopeso.co/", "/icons/nft-white.png"),
    createMenuItem("CRPminer Evolution", "https://tuprimermillon.cryptopeso.co/", "/icons/v4-white.png"),
    createMenuItem("Sparta Network", "https://sparta.cryptopeso.co/", "/icons/sparta-white.png"),
    createMenuItem("Sparta Evolution", "https://liquiditypool.cryptopeso.co/?ref=0x67c1CDc33cc36b206B0590C238bE93Ba5Cd0dc7A", "/icons/sparta-v2-white.png"),
    createMenuItem("Sparta Ascension", "https://v3.cryptopeso.co/", "/icons/sparta-v3-white.png", {
        new: true
    }),
    createMenuItem("Copy Trading", "https://copy.cryptopeso.co/?ref=0x67c1CDc33cc36b206B0590C238bE93Ba5Cd0dc7A", "/icons/copy-white.png", {
        new: true
    }),
    createMenuItem("CRP Bets", "https://bets.cryptopeso.com/", "/icons/bets-white.png"),
    createMenuItem("Sales Funnel", "https://evolutioncryptopeso.online/formulario/", "/icons/funnel-white.png"),
    createMenuItem("Tap El Patr\xf3n", "https://t.me/ElPatron_Oficial_Bot/start?startapp=907332338", "/icons/tap-pablo-white.png"),
    createMenuItem("Balotin", "https://balotin.sparklifestaking.tech/", "/icons/ticket-white.png"),
    createMenuItem("BetsChampionsLeague", "https://www.betschampionsleague.co/", "/icons/apuesta-white.png"),
    createMenuItem("S3mingChannel", "https://s3mingchannel.com/", "/icons/s3-white.png"),
    createMenuItem("Lend", "", "/icons/lend-white.png", {
        soon: true
    }),
    createMenuItem("CryptoCard", "https://wap.redotpay.com/es/invite/?referralId=mcpdx", "/icons/tarjeta-white.png"),
    createMenuItem("Whitepaper CryptoPeso CRP", "https://doc.cryptopeso.co", "/icons/whitepaper-white.png"),
    createMenuItem("Auditor\xeda CryptoPeso CRP", "https://blocksafu.com/audit/0x86333e34c8804532Ae34207c46e741cBc3Ff3FE3", "/icons/auditoria-white.png"),
    createMenuItem("KYC CryptoPeso CRP", "https://github.com/blocksafu111/kyc/blob/main/KYC-CryptoPeso-By-BlockSAFU.pdf", "/icons/auditoria-white.png"),
    createMenuItem("CRP Roadmap", "https://doc.cryptopeso.co/", "/icons/roadmap-white.png"), 
];
// Updated beatsEcosystem with new items
var beatsEcosystem = [
    createMenuItem("Beats Miner", "https://beatsminer.cryptopeso.co/", "/icons/v4-white.png"),
    createMenuItem("Beatsminer Evolution", "https://beatsminerv41.cryptopeso.co/", "/icons/v5-white.png"),
    createMenuItem("Beats Staking", "https://beatsstaking.cryptopeso.co", "/icons/staking-beats-white.png"),
    createMenuItem("Beats Airdrop", "https://beatsairdrop.cryptopeso.co", "/icons/beats-airdrop-white.png"),
    createMenuItem("Matrix Miner", "https://matrix.cryptopeso.co/", "/icons/matrix-white.png"),
    createMenuItem("Matrix AirDrop", "https://matrix.airdrop.cryptopeso.co/", "/icons/matrix-airdrop-white.png"),
    createMenuItem("CRP OLD x CRP", "https://docs.google.com/forms/d/e/1FAIpQLSeBUxxAAP1Qfe9WrqZmFaFmvsa6fzJ_HBjDDJNmJDMcQk2nIA/viewform?usp=pp_url", "/icons/whitepaper-white.png"),
    createMenuItem("Beats x CRP", "https://docs.google.com/forms/d/e/1FAIpQLSdK_tWDqzNpSf-F93as_eYvmha-MwVGQY51ODJf4h3XixLkPQ/viewform?usp=pp_url", "/icons/whitepaper-white.png"), 
];
// Updated socialNetworks with more platforms and white icons
var socialNetworks = [
    createMenuItem("Gmail", "mailto:soynewmanperez@gmail.com", "/icons/mail-white.png"),
    createMenuItem("Whatsapp", "https://spartacryptopeso.online/oficial", "/icons/wp-white.png"),
    createMenuItem("CryptoPeso Website", "https://www.cryptopeso.co", "/icons/web-crp-white.png"),
    createMenuItem("Telegram", "https://t.me/CryptoPesoColombia", "/icons/telegram-white.png"),
    createMenuItem("Tiktok", "https://www.tiktok.com/@soynewmanperez", "/icons/tiktok-white.png"),
    createMenuItem("Twitter", "https://x.com/Crypto__Peso", "/icons/x-white.png"),
    createMenuItem("Youtube", "https://youtube.com/@newmanperez?feature=shared", "/icons/youtube-white.png"),
    createMenuItem("Medium", "https://medium.com/@CryptoPeso"),
    createMenuItem("GitHub", "https://github.com/CryptoPeso"),
    createMenuItem("Reddit", "https://www.reddit.com/user/CryptoPesos/?rdt=42074"),
    createMenuItem("Slack", "https://cryptopesos.slack.com/team/U065B6BPGTT"),
    createMenuItem("BitcoinTalk", "https://bitcointalk.org/index.php?action=profile;u=3589276"),
    createMenuItem("LinkedIn", "https://www.linkedin.com/in/crypto-peso-92a26b286/"), 
];
var newsLinksNoticias = [
    {
        title: "Newman P\xe9rez se posiciona como el trader profesional del momento",
        url: "https://www.lajornadamaya.mx/quintanaroo/213827/newman-perez-se-posiciona-como-el-trader-profesional-del-momento"
    },
    {
        title: 'Newman P\xe9rez: "Invertir en criptomentas no es solo para ricos"',
        url: "https://diariolavoz.net/2023/05/05/newman-perez-invertir-en-criptomentas-no-es-solo-para-ricos/?amp=1"
    },
    {
        title: "Newman Perez: BNB Beats su proyecto estrella a recaudado m\xe1s de 50 millones de d\xf3lares",
        url: "https://www.noticias24hrs.com.ve/newman-perez-bnb-beats-su-proyecto-estrella-a-recaudado-mas-de-50-millones-de-dolares/"
    },
    {
        title: "2023, el a\xf1o millonario de Newman P\xe9rez",
        url: "https://www.diariodemexico.com/tendencias/2023-el-ano-millonario-de-newman-perez/amp"
    },
    {
        title: "BITCOIN Y BNB \xbfEl oro del futuro? esto dice Newman P\xe9rez sobre la Blockchain y sus riesgos",
        url: "https://forbes.co/2023/02/07/negocios/bitcoin-y-bnb-el-oro-del-futuro-esto-dice-newman-perez-sobre-la-blockchain-y-sus-riesgos"
    },
    {
        title: "\xbfQui\xe9n es Newman P\xe9rez? El criptoempresario es un fen\xf3meno en las redes",
        url: "https://www.eluniversal.com.co/informe-empresarial/2023/02/28/quien-es-newman-perez-el-criptoempresario-es-un-fenomeno-en-las-redes/"
    },
    {
        title: 'Newman P\xe9rez: "Invertir en criptomentas no es solo para ricos"',
        url: "https://diariolavoz.net/2023/05/05/newman-perez-invertir-en-criptomentas-no-es-solo-para-ricos/?amp=1"
    },
    {
        title: "Newman P\xe9rez - El Heraldo de M\xe9xico",
        url: "https://heraldodemexico.com.mx/temas/newman-perez-76012.html"
    }, 
];
function classNames() {
    for(var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++){
        classes[_key] = arguments[_key];
    }
    return classes.filter(Boolean).join(" ");
}
var Wrapper = styled.div.withConfig({
    componentId: "sc-99ef7966-0"
})(_templateObject());
var StyledNav = styled.nav.withConfig({
    componentId: "sc-99ef7966-1"
})(_templateObject1(), MENU_HEIGHT, function(param) {
    var theme = param.theme;
    return theme.nav.background;
}, function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
});
var FixedContainer = styled.div.withConfig({
    componentId: "sc-99ef7966-2"
})(_templateObject2(), function(param) {
    var showMenu = param.showMenu, height = param.height;
    return showMenu ? 0 : "-".concat(height, "px");
}, function(param) {
    var height = param.height;
    return "".concat(height, "px");
});
var TopBannerContainer = styled.div.withConfig({
    componentId: "sc-99ef7966-3"
})(_templateObject3(), function(param) {
    var height = param.height;
    return "".concat(height, "px");
}, function(param) {
    var height = param.height;
    return "".concat(height, "px");
}, function(param) {
    var height = param.height;
    return "".concat(height, "px");
});
var BodyWrapper = styled(Box).withConfig({
    componentId: "sc-99ef7966-4"
})(_templateObject4());
var Inner = styled.div.withConfig({
    componentId: "sc-99ef7966-5"
})(_templateObject5());
var Menu = function(param) {
    var _linkComponent = param.linkComponent, linkComponent = _linkComponent === void 0 ? "a" : _linkComponent, userMenu = param.userMenu, banner = param.banner, globalMenu = param.globalMenu, isDark = param.isDark, toggleTheme = param.toggleTheme, currentLang = param.currentLang, setLang = param.setLang, cakePriceUsd = param.cakePriceUsd, links = param.links, subLinks = param.subLinks, footerLinks = param.footerLinks, activeItem = param.activeItem, activeSubItem = param.activeSubItem, langs = param.langs, buyCakeLabel = param.buyCakeLabel, children = param.children;
    var ref = useMatchBreakpoints(), isMobile = ref.isMobile, isMd = ref.isMd;
    var ref1 = useState(true), showMenu = ref1[0], setShowMenu = ref1[1];
    var refPrevOffset = useRef("object" === "undefined" ? 0 : window.pageYOffset);
    var ref2 = useState(false), sidebarOpen = ref2[0], setSidebarOpen = ref2[1];
    var ref3 = useState("0xgj..."), accountDisplay = ref3[0], setAccountDisplay = ref3[1];
    var ref4 = useState(false), copied = ref4[0], setCopied = ref4[1];
    var topBannerHeight = isMobile ? TOP_BANNER_HEIGHT_MOBILE : TOP_BANNER_HEIGHT;
    var totalTopMenuHeight = banner ? MENU_HEIGHT + topBannerHeight : MENU_HEIGHT;
    useEffect(function() {
        var handleScroll = function() {
            var currentOffset = window.pageYOffset;
            var isBottomOfPage = window.document.body.clientHeight === currentOffset + window.innerHeight;
            var isTopOfPage = currentOffset === 0;
            if (isTopOfPage) {
                setShowMenu(true);
            } else if (!isBottomOfPage) {
                if (currentOffset < refPrevOffset.current || currentOffset <= totalTopMenuHeight) {
                    setShowMenu(true);
                } else {
                    setShowMenu(false);
                }
            }
            refPrevOffset.current = currentOffset;
        };
        var throttledHandleScroll = throttle(handleScroll, 200);
        window.addEventListener("scroll", throttledHandleScroll);
        return function() {
            window.removeEventListener("scroll", throttledHandleScroll);
        };
    }, [
        totalTopMenuHeight
    ]);
    var tabs = [
        {
            name: "Swap",
            href: "/swap",
            current: true
        },
        {
            name: "Limit",
            href: "/limit-orders",
            current: true
        },
        {
            name: "Liquidity",
            href: "/liquidity",
            current: true
        }, 
    ];
    var homeLink = links.find(function(link) {
        return link.label === "Home";
    });
    var subLinksWithoutMobile = subLinks === null || subLinks === void 0 ? void 0 : subLinks.filter(function(subLink) {
        return !subLink.isMobileOnly;
    });
    var subLinksMobileOnly = subLinks === null || subLinks === void 0 ? void 0 : subLinks.filter(function(subLink) {
        return subLink.isMobileOnly;
    });
    var ref5 = useCountdown([
        2023,
        4,
        15,
        20
    ]), timerDays = ref5.timerDays, timerHours = ref5.timerHours, timerMinutes = ref5.timerMinutes, timerSeconds = ref5.timerSeconds;
    var DAI_ADDRESS = "0x86333e34c8804532ae34207c46e741cbc3ff3fe3";
    var DAI_SYMBOL = "CRP";
    var DAI_DECIMALS = 18;
    var DAI_IMAGE = "https://miner.cryptopeso.co/crypto-pesos.png";
    function connectMetaMask() {
        return _connectMetaMask.apply(this, arguments);
    }
    function _connectMetaMask() {
        _connectMetaMask = // Simulate MetaMask functions (keeping original functionality)
        _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
            return regeneratorRuntime.wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!window.ethereum) {
                            _ctx.next = 11;
                            break;
                        }
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return window.ethereum.request({
                            method: "eth_requestAccounts"
                        });
                    case 4:
                        _ctx.next = 9;
                        break;
                    case 6:
                        _ctx.prev = 6;
                        _ctx.t0 = _ctx["catch"](1);
                        console.error("El usuario rechaz\xf3 la conexi\xf3n", _ctx.t0);
                    case 9:
                        _ctx.next = 12;
                        break;
                    case 11:
                        {
                            alert("Por favor instala MetaMask primero.");
                        }
                    case 12:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    6
                ]
            ]);
        }));
        return _connectMetaMask.apply(this, arguments);
    }
    function addToMetaMask() {
        return _addToMetaMask.apply(this, arguments);
    }
    function _addToMetaMask() {
        _addToMetaMask = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
            var wasAdded;
            return regeneratorRuntime.wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        if (!(!window.ethereum || !window.ethereum.isMetaMask)) {
                            _ctx.next = 4;
                            break;
                        }
                        alert("Por favor instala MetaMask primero.");
                        return _ctx.abrupt("return");
                    case 4:
                        _ctx.next = 6;
                        return connectMetaMask();
                    case 6:
                        _ctx.next = 8;
                        return window.ethereum.request({
                            method: "wallet_watchAsset",
                            params: {
                                type: "ERC20",
                                options: {
                                    address: DAI_ADDRESS,
                                    symbol: DAI_SYMBOL,
                                    decimals: DAI_DECIMALS,
                                    image: DAI_IMAGE
                                }
                            }
                        });
                    case 8:
                        wasAdded = _ctx.sent;
                        if (wasAdded) {
                            toast.success("Token agregado a MetaMask");
                        } else {
                            toast.success("El token ya estaba agregado");
                        }
                        _ctx.next = 15;
                        break;
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](0);
                        console.error("Hubo un error al agregar el token a MetaMask", _ctx.t0);
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12
                ]
            ]);
        }));
        return _addToMetaMask.apply(this, arguments);
    }
    // Simulate wallet connection
    var connectWallet = function() {
        connectMetaMask();
    };
    // Simulate copy to clipboard
    var copyToClipboard = function() {
        navigator.clipboard.writeText("0x86333e34c8804532ae34207c46e741cbc3ff3fe3").then(function() {
            setCopied(true);
            toast.success("Direcci\xf3n copiada al portapapeles");
            setTimeout(function() {
                setCopied(false);
            }, 2000);
        });
    };
    return /*#__PURE__*/ _jsxs(MenuContext.Provider, {
        value: {
            linkComponent: linkComponent
        },
        children: [
            /*#__PURE__*/ _jsx(CarouselBanner, {}),
            /*#__PURE__*/ _jsx(Wrapper, {
                children: /*#__PURE__*/ _jsxs("div", {
                    children: [
                        /*#__PURE__*/ _jsx("main", {
                            children: /*#__PURE__*/ _jsx("div", {
                                className: "pt-[calc(16.67vw+32px)] lg:pt-8",
                                children: /*#__PURE__*/ _jsx(BodyWrapper, {
                                    mt: !subLinks ? "".concat(totalTopMenuHeight + 1, "px") : "0",
                                    children: /*#__PURE__*/ _jsxs(Inner, {
                                        isPushed: false,
                                        showMenu: showMenu,
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex justify-center",
                                                children: /*#__PURE__*/ _jsx("img", {
                                                    className: "h-12 w-auto px-8 object-contain",
                                                    src: "/logo-yellow.png",
                                                    alt: ""
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx(TradeTabs, {}),
                                            children,
                                            /*#__PURE__*/ _jsx(Footer, {})
                                        ]
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            "data-testid": "bottom-navigation",
                            role: "navigation",
                            "aria-label": "Quick actions",
                            className: "fixed bottom-1 left-0 right-0 z-50 border-t border-amber-800/30 shadow-xl",
                            style: {
                                background: "#0F0A06",
                                boxShadow: "0 -4px 6px -1px rgba(0, 0, 0, 0.5)"
                            },
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "grid grid-cols-2 p-1 border-b border-amber-800/20 bg-black/90",
                                    children: [
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "flex items-center justify-center p-1 border-x border-amber-800/20",
                                            children: [
                                                /*#__PURE__*/ _jsx(ImgS3, {
                                                    src: "/icons/crp-money.png",
                                                    alt: "CRP",
                                                    className: "h-5 w-5 mr-2"
                                                }),
                                                /*#__PURE__*/ _jsxs("div", {
                                                    className: "flex flex-col",
                                                    children: [
                                                        /*#__PURE__*/ _jsx("span", {
                                                            className: "text-[10px] text-amber-500",
                                                            children: "Price CRP"
                                                        }),
                                                        /*#__PURE__*/ _jsxs("span", {
                                                            className: "text-xs text-white font-mono",
                                                            children: [
                                                                /*#__PURE__*/ _jsx(TokenPrice, {}),
                                                                " $"
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "flex items-center justify-center p-1",
                                            children: [
                                                /*#__PURE__*/ _jsx(ImgS3, {
                                                    src: "/bnb.png",
                                                    alt: "BNB",
                                                    className: "h-5 w-5 mr-2"
                                                }),
                                                /*#__PURE__*/ _jsxs("div", {
                                                    className: "flex flex-col",
                                                    children: [
                                                        /*#__PURE__*/ _jsx("span", {
                                                            className: "text-[10px] text-amber-500",
                                                            children: "Price BNB"
                                                        }),
                                                        /*#__PURE__*/ _jsxs("span", {
                                                            className: "text-xs text-white font-mono",
                                                            children: [
                                                                /*#__PURE__*/ _jsx(PriceBNB, {}),
                                                                " $"
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "grid grid-cols-4 items-stretch h-12",
                                    children: [
                                        /*#__PURE__*/ _jsxs("button", {
                                            onClick: function() {
                                                return setSidebarOpen(true);
                                            },
                                            className: "flex flex-col items-center justify-center py-1 bg-gradient-to-b from-red-800 to-red-900 text-white transition-colors hover:from-red-700 hover:to-red-800",
                                            children: [
                                                /*#__PURE__*/ _jsx(Bars3Icon, {
                                                    className: "h-5 w-5 mb-0.5"
                                                }),
                                                /*#__PURE__*/ _jsx("span", {
                                                    className: "text-[11px] font-medium",
                                                    children: "MENU"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx("a", {
                                            style: {
                                                background: "linear-gradient(0deg, #000 46.06%, #666 111.6%)"
                                            },
                                            target: "_blank",
                                            rel: "noreferrer",
                                            href: "https://poocoin.app/tokens/0x86333e34c8804532ae34207c46e741cbc3ff3fe3",
                                            className: "flex items-center justify-center py-1 bg-gradient-to-b from-green-800 to-green-900 text-white border-x border-amber-900/20 transition-colors hover:from-green-700 hover:to-green-800",
                                            children: /*#__PURE__*/ _jsx("div", {
                                                className: "flex items-center justify-center h-full w-full",
                                                children: /*#__PURE__*/ _jsx(ImgS3, {
                                                    src: "/buy-crp.png",
                                                    alt: "Buy",
                                                    className: "h-11 w-auto object-contain"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ _jsxs("button", {
                                            onClick: addToMetaMask,
                                            className: "flex flex-col items-center justify-center py-1 bg-gradient-to-b from-amber-600 to-amber-700 text-white transition-colors hover:from-amber-500 hover:to-amber-600",
                                            children: [
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "text-lg leading-none mb-0.5",
                                                    children: "\uD83E\uDD8A"
                                                }),
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "flex flex-col items-center",
                                                    children: /*#__PURE__*/ _jsx("span", {
                                                        className: "text-[11px] font-medium",
                                                        children: "Add Token"
                                                    })
                                                })
                                            ]
                                        }),
                                        userMenu
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "h-24 mb-0"
                        }),
                        /*#__PURE__*/ _jsx(Transition.Root, {
                            show: sidebarOpen,
                            as: Fragment,
                            children: /*#__PURE__*/ _jsxs(Dialog, {
                                as: "div",
                                className: "relative z-[9999999999]",
                                onClose: setSidebarOpen,
                                children: [
                                    /*#__PURE__*/ _jsx(Transition.Child, {
                                        as: Fragment,
                                        enter: "transition-opacity ease-linear duration-300",
                                        enterFrom: "opacity-0",
                                        enterTo: "opacity-100",
                                        leave: "transition-opacity ease-linear duration-300",
                                        leaveFrom: "opacity-100",
                                        leaveTo: "opacity-0",
                                        children: /*#__PURE__*/ _jsx("div", {
                                            className: "fixed inset-0 bg-black/80"
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "fixed inset-0 z-[999999999999] flex",
                                        children: /*#__PURE__*/ _jsx(Transition.Child, {
                                            as: Fragment,
                                            enter: "transition ease-in-out duration-300 transform",
                                            enterFrom: "-translate-x-full",
                                            enterTo: "translate-x-0",
                                            leave: "transition ease-in-out duration-300 transform",
                                            leaveFrom: "translate-x-0",
                                            leaveTo: "-translate-x-full",
                                            children: /*#__PURE__*/ _jsxs(Dialog.Panel, {
                                                className: "relative flex w-full max-w-xs flex-1 flex-col pt-5 pb-4 bg-center bg-no-repeat bg-black bg-cover",
                                                style: {
                                                    backgroundImage: "url(".concat(getS3Url_V3("/bg-menu.png"), ")")
                                                },
                                                children: [
                                                    /*#__PURE__*/ _jsx(Transition.Child, {
                                                        as: Fragment,
                                                        enter: "ease-in-out duration-300",
                                                        enterFrom: "opacity-0",
                                                        enterTo: "opacity-100",
                                                        leave: "ease-in-out duration-300",
                                                        leaveFrom: "opacity-100",
                                                        leaveTo: "opacity-0",
                                                        children: /*#__PURE__*/ _jsx("div", {
                                                            className: "absolute top-0 right-0 -mr-12 pt-2",
                                                            children: /*#__PURE__*/ _jsxs("button", {
                                                                type: "button",
                                                                className: "ml-1 flex h-10 w-10 items-center justify-center rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white",
                                                                onClick: function() {
                                                                    return setSidebarOpen(false);
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ _jsx("span", {
                                                                        className: "sr-only",
                                                                        children: "Close sidebar"
                                                                    }),
                                                                    /*#__PURE__*/ _jsx(XMarkIcon, {
                                                                        className: "h-6 w-6 text-white",
                                                                        "aria-hidden": "true"
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "flex flex-shrink-0 items-center justify-center px-4 py-4",
                                                        children: /*#__PURE__*/ _jsx("img", {
                                                            className: "h-8 w-auto",
                                                            src: "/logo-yellow.png",
                                                            alt: "Sparta Network"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "mx-auto mb-4 mt-2 h-px w-3/4 bg-gradient-to-r from-transparent via-amber-600 to-transparent"
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "mt-1 h-0 flex-1 overflow-y-auto",
                                                        children: /*#__PURE__*/ _jsxs("nav", {
                                                            className: "space-y-1 px-2 font-primary",
                                                            children: [
                                                                navigation.slice(0, 10).map(function(item) {
                                                                    return /*#__PURE__*/ _jsxs("a", {
                                                                        href: item.href,
                                                                        className: clsx("group flex items-center rounded-md px-3 py-2 text-sm transition-colors", "border border-amber-900/20 bg-black/30 hover:bg-amber-900/20", item.current ? "font-bold text-white" : "font-bold text-white", item.soon && "opacity-75"),
                                                                        style: {
                                                                            boxShadow: "0 1px 2px rgba(255, 150, 0, 0.05)"
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx(ImgS3, {
                                                                                src: item.src,
                                                                                alt: "",
                                                                                className: "mr-3 h-auto w-5"
                                                                            }),
                                                                            item.name,
                                                                            item.new && /*#__PURE__*/ _jsx("span", {
                                                                                className: "ml-4 inline-flex items-center rounded bg-amber-600 px-1.5 py-0.5 text-[8px] font-bold text-white",
                                                                                children: "NEW"
                                                                            }),
                                                                            item.soon && /*#__PURE__*/ _jsx("span", {
                                                                                className: "ml-4 inline-flex items-center rounded bg-amber-600 px-1.5 py-0.5 text-[8px] font-bold text-white",
                                                                                children: "SOON"
                                                                            })
                                                                        ]
                                                                    }, item.name);
                                                                }),
                                                                /*#__PURE__*/ _jsx(DisclosureMenu, {
                                                                    title: "CryptoPeso",
                                                                    icon: "/icons/crp-money.png",
                                                                    items: cryptoPeso
                                                                }),
                                                                /*#__PURE__*/ _jsx(DisclosureMenu, {
                                                                    title: "Beats Ecosystem",
                                                                    icon: "/icons/beats-money.png",
                                                                    items: beatsEcosystem
                                                                }),
                                                                /*#__PURE__*/ _jsx(DisclosureMenu, {
                                                                    title: "CRP News",
                                                                    icon: "/icons/news-white.png",
                                                                    items: newsLinksNoticias,
                                                                    isLink: true
                                                                }),
                                                                /*#__PURE__*/ _jsx(DisclosureMenu, {
                                                                    title: "Contacto",
                                                                    items: socialNetworks
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ _jsx(Toaster, {
                            position: "top-right",
                            toastOptions: {
                                style: {
                                    background: "#363636",
                                    color: "#fff"
                                },
                                iconTheme: {
                                    primary: "#eab308",
                                    secondary: "#000"
                                }
                            }
                        })
                    ]
                })
            })
        ]
    });
};
export default Menu;
function DisclosureMenu(param1) {
    var title = param1.title, icon = param1.icon, items = param1.items, isLink = param1.isLink;
    return /*#__PURE__*/ _jsx(Disclosure, {
        as: "div",
        className: "mt-2",
        children: function(param) {
            var open = param.open;
            return /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsxs(Disclosure.Button, {
                        className: "group flex w-full items-center justify-between rounded-md border border-amber-900/20 bg-black/30 px-3 py-2 text-sm font-bold text-white hover:bg-amber-900/20",
                        style: {
                            boxShadow: "0 1px 2px rgba(255, 150, 0, 0.05)"
                        },
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "flex items-center",
                                children: [
                                    icon && /*#__PURE__*/ _jsx(ImgS3, {
                                        src: icon,
                                        alt: "",
                                        className: "mr-3 h-auto w-5"
                                    }),
                                    title
                                ]
                            }),
                            /*#__PURE__*/ _jsx(ChevronDownIcon, {
                                className: clsx(open ? "-rotate-180" : "rotate-0", "h-4 w-4 transition-transform duration-200 text-white")
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(Disclosure.Panel, {
                        className: "mt-1 space-y-1 pl-2",
                        children: items.map(function(item, i) {
                            return isLink ? /*#__PURE__*/ _jsx("a", {
                                href: item.url,
                                className: "my-1 block rounded border border-amber-900/10 bg-black/20 p-2 text-xs text-white hover:bg-amber-900/10",
                                children: item.title
                            }, i) : /*#__PURE__*/ _jsxs(Link, {
                                href: item.href,
                                className: clsx("group flex items-center rounded border border-amber-900/10 bg-black/20 px-3 py-1.5 text-xs transition-colors", "hover:bg-amber-900/10", item.current ? "font-bold text-white" : "font-bold text-white"),
                                children: [
                                    item.src && /*#__PURE__*/ _jsx(ImgS3, {
                                        src: item.src,
                                        alt: "",
                                        className: "mr-2 h-auto w-4"
                                    }),
                                    item.name,
                                    item.new && /*#__PURE__*/ _jsx("span", {
                                        className: "ml-2 inline-flex items-center rounded bg-amber-600 px-1 py-px text-[8px] font-bold text-white",
                                        children: "NEW"
                                    }),
                                    item.soon && /*#__PURE__*/ _jsx("span", {
                                        className: "ml-2 inline-flex items-center rounded bg-amber-600 px-1 py-px text-[8px] font-bold text-white",
                                        children: "SOON"
                                    })
                                ]
                            }, item.name);
                        })
                    })
                ]
            });
        }
    });
}
